export default class LocationModel {
  constructor(item) {
    const { id, locationGroupId, name, shapeType, shape, status } = item
    this.id = id
    this.locationGroupId = locationGroupId
    this.name = name === undefined ? 'poi location' : name //poi locationはnameを持たない
    this.shapeType = shapeType
    this.shape = shape
    this.status = status === undefined ? 'active' : status //poi locationはstatusを持たない
  }

  get isActive() {
    return this.status === 'active'
  }

  static assign(data) {
    return new LocationModel(data)
  }
}
